import { filter } from "rxjs/operators";
import React, { useLayoutEffect } from "react";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";

import { viewingReorder } from "./atoms";
import { currentPlaylist } from "./atoms";

import {
  reorder,
  currentOrder,
  futureOrderChanged,
  futureOrderData,
} from "./sort_atoms";

import { commands$, REORDER } from "./CommandsStream";

import { PlayerModal } from "./PlayerModal";

const reorderCommands$ = commands$.stream.pipe(
  filter(({ action }) => [REORDER].includes(action))
);

export function ReorderModal({ onSave }) {
  const playlist = useRecoilValue(currentPlaylist);
  const [open, setOpen] = useRecoilState(viewingReorder);
  const setInitialOrder = useSetRecoilState(currentOrder);
  const resetOrderChanged = useSetRecoilState(futureOrderChanged);
  const futureOrder = useRecoilValue(futureOrderData);

  useLayoutEffect(() => {
    const subscription = reorderCommands$.subscribe(({ action }) => {
      setOpen(action === REORDER);

      setInitialOrder(playlist);

      resetOrderChanged(false);
    });

    return () => subscription.unsubscribe();
  }, [setOpen, playlist, setInitialOrder, resetOrderChanged]);

  const save = () => {
    onSave(reorder(playlist, futureOrder.indexes));
    setOpen(false);
  };

  const cancel = () => {
    setOpen(false);
  };

  return (
    <PlayerModal open={open} transparent>
      <PlayerModal.Save onClick={save} />
      <PlayerModal.Cancel onClick={cancel} />
    </PlayerModal>
  );
}
